import React from 'react';
import { Link } from 'react-router-dom';
import { EVENTS } from '../../data/smaken';
import { Reveal } from '../Reveal';
import { ArrowMark, Note } from '../Marks';
export function EventsSection() {
  return <section aria-labelledby="upplev-rubrik" className="bg-beta text-papper" data-id="element-408" data-mp="2bz5jmpeyrnkp">
      <div className="mx-auto max-w-page px-5 py-16 md:px-8 md:py-24" data-id="element-409" data-mp="27z54t3nydad4">
        <Reveal data-id="element-410" data-mp="27wsoeuxuf826">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-411" data-mp="22z92d8uwlqzo">
            <div data-id="element-412" data-mp="22x611soawbfn">
              <h2 id="upplev-rubrik" className="display-xl text-5xl uppercase leading-[0.9] sm:text-7xl" data-id="element-413" data-mp="1y0pcwyh3px2k">
                Ät inte bara.
                <br data-id="element-414" data-mp="1t2e66wm3s2ok" />
                Upplev.
              </h2>
              <Note className="mt-4 block !text-smor" data-id="element-415" data-mp="1p010273g22r9">Det här vill du inte missa.</Note>
            </div>
            <Link to="/upptack?kategori=upplev" className="group flex items-center gap-2 text-[12px] font-bold uppercase tracking-wide2 transition-colors duration-150 ease-out hover:text-smor" data-id="element-416" data-mp="3nfvuiluc13kn">
              Alla upplevelser
              <ArrowMark className="h-4 w-9 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-417" data-mp="2813twhb1ezl2" />
            </Link>
          </div>
        </Reveal>

        <ul className="mt-14 border-t border-papper/25" data-id="element-418" data-mp="1yznvz91espxq">
          {EVENTS.map((event, i) => <Reveal key={event.id} delay={Math.min(i * 0.05, 0.18)} data-id="element-419" data-mp="230pol70tm3qq" data-mpi={i}>
              <li data-id="element-420" data-mp="2qp0jltju5973">
                <Link to="/upptack?kategori=upplev" className="group grid items-baseline gap-3 border-b border-papper/25 py-7 sm:grid-cols-[5.5rem,minmax(0,1fr),auto] sm:gap-8" data-id="element-421" data-mp="2qqjzhj1kxi8c">
                  <div className="flex items-baseline gap-2 sm:block" data-id="element-422" data-mp="2hwymo58z6b1k">
                    <span className="display-xl block text-4xl leading-none" data-id="element-423" data-mp="2lxhe3y6yhf38">{event.day}</span>
                    <span className="text-[11px] font-bold uppercase tracking-wide2 text-papper/60" data-id="element-424" data-mp="39nbng5s2gliq">
                      {event.month}
                    </span>
                  </div>

                  <div data-id="element-425" data-mp="3obd6kaw2lmef">
                    <h3 className="font-display text-2xl uppercase transition-colors duration-150 ease-out group-hover:text-smor sm:text-3xl" data-id="element-426" data-mp="3oajv4wm628py">
                      {event.name}
                    </h3>
                    <p className="mt-1.5 text-[11px] font-semibold uppercase tracking-wide2 text-papper/60" data-id="element-427" data-mp="3f8u4ht03zdt8">
                      {event.place} · {event.city} · {event.time}
                    </p>
                    <p className="mt-2 text-papper/70" data-id="element-428" data-mp="35dse6tu3k5p2">{event.kicker}</p>
                  </div>

                  <span className={`flex items-center gap-2 whitespace-nowrap text-[12px] font-bold uppercase tracking-wide2 ${event.soldOut ? 'text-papper/40' : ''}`} data-id="element-429" data-mp="30jy0q8534myf">
                    {event.soldOut ? 'Slutsålt' : 'Se event'}
                    {!event.soldOut && <ArrowMark className="h-3.5 w-8 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-430" data-mp="2hm4wn2iq66zg" />}
                  </span>
                </Link>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}